import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'

/** Closed panels do not mount their contents or start background requests. */
export function ReleaseDisclosure({ id, open, onToggle, summary, children, className = '' }: {
  id: string; open: boolean; onToggle: () => void; summary: ReactNode; children: ReactNode; className?: string
}) {
  return <div className={className}>
    <button type="button" aria-expanded={open} aria-controls={id} onClick={onToggle} className="flex min-h-12 w-full items-center gap-3 rounded-lg px-4 py-3 text-start transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400">
      <span className="min-w-0 flex-1">{summary}</span>
      <ChevronDown aria-hidden="true" size={18} className={`shrink-0 text-gray-400 transition-transform motion-reduce:transition-none ${open ? 'rotate-180' : ''}`} />
    </button>
    <div id={id} hidden={!open}>{open ? children : null}</div>
  </div>
}
